import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import withWidth from "@material-ui/core/withWidth/withWidth";

import { changeAccount, changeSelRole } from "./../redux";
import { handleSignInWithGoogle, anonymousSignIn } from "./../firebaseApi";
import { Typography, Paper, Button } from "@material-ui/core";

const styles = (theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    marginTop: theme.spacing(20),
    width: "100%",
    maxWidth: "400px",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  button: {
    marginTop: theme.spacing(3),
  },
});

function MainLogin(props) {
  let mobile = props.width === "xs";
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Paper className={props.classes.paper}>
        <Typography
          variant="h2"
          style={{
            fontWeight: "bold",
            fontSize: "clamp(2rem, 15vw, 3.8rem)",
          }}
        >
          Webclicker
        </Typography>
        <img
          src={`${process.env.PUBLIC_URL}/free_icon_1.svg`}
          alt="Webclicker Icon"
          style={{
            width: "60px",
            height: "60px",
            marginTop: "10px",
            marginBottom: "30px",
          }}
        />
        <Button
          className={props.classes.button}
          fullWidth
          variant="outlined"
          onClick={async () => {
            try {
              await handleSignInWithGoogle().then((accountDetails) => {
                props.changeAccount(accountDetails);
                props.history.push("/loading");
              });
            } catch (err) {}
          }}
        >
          Sign in with Google
        </Button>

        <Button
          className={props.classes.button}
          style={{ marginTop: "15px" }}
          fullWidth
          variant="outlined"
          onClick={async () => {
            try {
              anonymousSignIn().then((accountDetails) => {
                props.changeAccount(accountDetails);
                props.history.push("/loading");
                
              });
            } catch (e) {
              //console.error(e);
            }
          }}
        >
          Vote Anonymously
        </Button>
      </Paper>

      <Button
        variant="text"
        style={{
          position: "absolute",
          bottom: "10px",
          right: "10px",
          textTransform: "none",
          textDecoration: "underline",
        }}
        onClick={() => {
          props.history.push("/secondary_login");
        }}
      >
        Legacy Webclicker Login
      </Button>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeAccount: (data) => dispatch(changeAccount(data)),
    changeSelRole: (data) => dispatch(changeSelRole(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(MainLogin))));
